import gql from 'graphql-tag';

/**
 * A page of a channel's reservables with just what a room card shows: the
 * room's details and its booking settings (opening hours, step size, rules). The
 * admin calendar's getReservablesOnChannelQuery also loads every room's
 * bookings and features, which a card has no use for.
 */
export const getChannelReservablesQuery = gql(/* GraphQL */ `
  query getChannelReservables(
    $channelId: UUID
    $pageSize: Int!
    $after: String
    $search: CalendarReservablesSearchInput
  ) {
    channel(_id: $channelId) {
      _id
      calendarReservables(first: $pageSize, after: $after, search: $search) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            type
            description
            backgroundImageId
            logoId
            timeZone
            features {
              type
              feature
            }
          }
        }
      }
    }
  }
`);
